// extracted by mini-css-extract-plugin
export default {"container":"xo-z","brandName":"yo-z","productName":"zo-z","productNamePdpEnhancements":"Ao-z","breakLongProductName":"Bo-z"};